import React, { useState, useEffect } from 'react';
import userService from '../services/user';
import utils from '../utils/utils';
import { NavLink, Redirect } from "react-router-dom";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import keys from '../store/keys';
import moment from 'moment';
import DeliveryAddress from './DeliveryAddress';

function Profile({ session, setKey, ...props }) {

    const [firstname, setFirstname] = useState(session.user.firstname);
    const [lastname, setLastname] = useState(session.user.lastname);
    const [dob, setDoB] = useState(moment(session.user.dob).format("YYYY-MM-DD"));
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [redirectTo, setRedirectTo] = useState(null);

    const handleSubmit = e => {
        e.preventDefault();
        if (!firstname || !lastname || !dob) {
            setErrorMessage(`Please provide all fields.`);
            return;
        }

        setKey(keys.isLoading, true);
        userService.signup({ firstname, lastname, dob })
            .then(result => {
                if (result.error) {
                    setErrorMessage(result.error);
                    setKey(keys.isLoading, false);
                    return;
                }

                const data = result.data;
                setErrorMessage('');
                setSuccessMessage(`Signup successfully! Please check your mailbox to activate your account.`);
                setKey(keys.isLoading, false);
            });
    }

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <div className="row mt-10">
                <div className="col">
                    <p className="cart-title">My Details</p>
                </div>
            </div>
            <div className="box">
                <div className="row mt-10 mb-10">
                    <div className="col-1 text-center">
                        <i className="fa-solid fa-circle-user"></i>
                    </div>
                    <div className="col-11" style={{ marginLeft: -40 }}>
                        <span>{session.user.d_firstname}</span> <span>{session.user.d_lastname}</span><br />
                        <span>{session.user.line1}</span><br />
                        <span>{session.user.line2}</span><br />
                        <span>{session.user.postcode}</span><br />
                        <span>{session.user.city}</span><br />
                        <span>{session.user.country}</span>
                    </div>
                </div>
            </div>
            <div className="box mt-10">
                <div className="row mt-10 mb-10">
                    <div className="col-1 text-center">
                        <i className="fa-solid fa-phone"></i>
                    </div>
                    <div className="col-11" style={{ marginLeft: -40 }}>
                        <span>{session.user.phone}</span>
                    </div>
                </div>
            </div>
            <div className="box mt-10">
                <div className="row mb-10 mt-10">
                    <div className="col-1 text-center">
                        <i className="fa-solid fa-gift"></i>
                    </div>
                    <div className="col-11" style={{ marginLeft: -40 }}>
                        <span>{utils.dayMonthYearFormat(session.user.dob)}</span>
                    </div>
                </div>
            </div>
            <div className="box mt-10">
                <div className="row mb-10 mt-10">
                    <div className="col-1 text-center">
                        <i className="fa-solid fa-envelope"></i>
                    </div>
                    <div className="col-11" style={{ marginLeft: -40 }}>
                        <span>{session.user.email}</span>
                    </div>
                </div>
            </div>
            <div className="box" style={{ borderTop: 0 }}>
                <div className="row mb-10 mt-10">
                    <div className="col-1 text-center">
                        <i className="fa-solid fa-lock"></i>
                    </div>
                    <div className="col-11" style={{ marginLeft: -40 }}>
                        <span>************</span>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
    setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
